import React, { useEffect, useRef, useState, useCallback } from "react";
import "./Stats.css";
import { API_BASE_URL } from "../config";

const Stats = () => {
  const statsRef = useRef(null);

  const [statsData, setStatsData] = useState([]);
  const [animatedStats, setAnimatedStats] = useState([]);
  const [hasAnimated, setHasAnimated] = useState(false);

  /* ===== FETCH STATS ===== */
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/stats`)
      .then((res) => res.json())
      .then((data) => {
        const stats = [
          { number: data.rpc, suffix: "+", label: "RPC Certified" },
          { number: data.instructors, suffix: "+", label: "Instructors" },
          { number: data.reviews, suffix: "+", label: "Reviews" },
        ];

        setStatsData(stats);
        setAnimatedStats(stats.map(() => 0));
        setHasAnimated(false);
      })
      .catch((err) => console.error("Stats fetch error:", err));
  }, []);

  /* ===== COUNT ANIMATION ===== */
  const animateCount = useCallback(() => {
    const duration = 1600;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);

      setAnimatedStats(
        statsData.map((stat) => Math.floor(progress * stat.number)),
      );

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [statsData]);

  /* ===== OBSERVE VISIBILITY ===== */
  useEffect(() => {
    if (!statsData.length) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          animateCount();
          setHasAnimated(true);
          entry.target.classList.add("fade-show");
        }
      },
      { threshold: 0.4 },
    );

    if (statsRef.current) observer.observe(statsRef.current);

    return () => observer.disconnect();
  }, [statsData, hasAnimated, animateCount]);

  return (
    <section className="stats-section fade-item" ref={statsRef}>
      <div className="stats-container">
        {/* HEADING ON TOP */}
        <h2 className="flytutor-main-heading">Our Achievements</h2>

        {/* STATS BELOW */}
        <div className="stats-grid">
          {statsData.map((stat, i) => (
            <div key={i} className="stats-card">
              <h3 className="stats-number">
                {animatedStats[i]}
                <span className="stats-suffix">{stat.suffix}</span>
              </h3>
              <p className="stats-label">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
